// Nav.tsx
import React from 'react';
import '../styles/nav.css'; // Adjust the path if needed

interface NavProps {
  scrollToSlide: (index: number) => void;
  scrollToCarousel: () => void; // Function to scroll to the carousel
  scrollToContact: () => void; // Optional function to scroll to contact section
}


const Nav: React.FC<NavProps> = ({scrollToSlide, scrollToCarousel, scrollToContact}) => {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md bg-white/80 shadow-md py-2">
      <div className="nav-container">
        <div className="nav-buttons">
          <button onClick={() => {scrollToCarousel(); scrollToSlide(0)}}className="nav-button">Våra produkter</button>
          <button onClick={() => {scrollToCarousel(); scrollToSlide(1)}} className="nav-button">Våra bigårdar</button>
          <button onClick={() => {scrollToCarousel(); scrollToSlide(2)}} className="nav-button">Om oss</button>
          <button className="contact-button" onClick={() => scrollToContact()} >Kontakta oss</button>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
